import OfferDocIndex from "@/views/offer-document/OfferDocIndex.vue";

const offerDoc = [
    {
        path: '/offerdocuments',
        name: 'offerdocument',
        component: OfferDocIndex
    }
]

export default offerDoc